// Payment status
const paymentStatus = {}
paymentStatus[(paymentStatus['Pagado'] = 'CHARGED')] = 'Pagado'
paymentStatus[(paymentStatus['Pendiente'] = 'PENDING')] = 'Pendiente'
paymentStatus[(paymentStatus['Fallido'] = 'FAILED')] = 'Fallido'

export default paymentStatus
